export const CourierValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.vc_Courier.trim()) {
      errors.vc_Courier = 'Courier is required';
    } 
    if (!formData.mon_Charge.trim()) {
        errors.mon_Charge = 'Mon Charge is required';
      } 
  
    return errors;
  };
  
 